module.exports = __webpack_public_path__ + "img/projects.ed9a8a2d.svg";